import BaseModel from './BaseModel';

export default class QmSystem extends BaseModel {
  constructor({
    id,
    number = undefined,
    designation = undefined,
    // DB column name — used when data comes from the browser without aliasing
    no = undefined,
  }) {
    super(id, number || no, designation);
    this.number = number || no;
    this.designation = designation;
  }

  static get fkName() {
    return 'qm_system_id';
  }

  get fkName() {
    return QmSystem.fkName;
  }

  static get apiRoute() {
    return 'qm_system';
  }

  static get listPageRoute() {
    return 'QmSystemList';
  }

  get apiRoute() {
    return QmSystem.apiRoute;
  }

  static get detailPageRoute() {
    return 'qmSystemDetail';
  }

  get detailPageRoute() {
    return QmSystem.detailPageRoute;
  }

  static get listDisplayAttrs() {
    return this.getAttributes(['number', 'designation', 'active']);
  }

  static get detailAttrs() {
    return this.getAttributes(['number', 'designation', 'active']);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes(['number', 'designation', 'active']);
  }

  static get joinAttrsKey() {
    return ['number', 'designation', 'active'];
  }

  static get orderKey() {
    return 'designation';
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE(),
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '2fr'}),
      this.ACTIVE_ATTRIBUTE(),
    ];
  }
}
